import { DropDown, SelectOption } from '@boschebike/ebds-react';
import { FunctionComponent, PropsWithChildren, useContext } from 'react';
import { RoutingContext } from '../../../context/routingContext';
import { PageNavigationProps } from '../types';

export const PageNavigationMobile: FunctionComponent<PropsWithChildren<PageNavigationProps>> = ({ links }) => {
  const { activeTab, setTab } = useContext(RoutingContext);
  const selectedOption = links.find((l) => l.route === activeTab)?.route ?? '';
  const selectionOptions: SelectOption[] = links.map((s) => ({
    value: s.route,
    label: s.text,
  }));

  return (
    <DropDown
      name="terms-of-user-service-selector"
      label=""
      options={selectionOptions}
      value={selectedOption}
      onChange={(newValue: string) => {
        setTab(newValue);
      }}
      withBottomGap
    />
  );
};
